export default {
    general: {
        invalid_password: 'Password must contain a minimum of 8 characters',
        invalid_verify_password: 'Passwords do not match',
    },
    signup: {
        password: 'Password',
        verify_password: 'Verify Password',
        email: 'Email',
        send_request: 'Send Request',
        title: 'SignUp',
        error: 'Error',
        email_taken: 'Email address is already in use',
        on_request_confirmed:
            'Once your request is approved, you will recieve an email in order to complete your signup process.',
        request_sent: 'Signup request has been sent successfully!',
        error_first_name: 'Invalid First Name',
        error_last_name: 'Invalid Last Name',
        error_id: 'Invalid Id',
        error_instructor: 'Invalid Instructor Type',
        error_cell_num: 'Invalid Mobile Phone',
        error_phone: 'Invalid Phone',
        error_address: 'Invalid Address',
        error_email: 'Invalid Email Address',
        error_password: 'Invalid Password',
        error_verify_password: 'Invalid Verify Password',
    },
    forgot_password: {
        email: 'Email',
        title: 'Forgot Password',
        send: 'Send',
        description: 'Enter your email address and press "send"',
        error: 'Error',
        unvalid_email: 'Invalid Email Address',
        email_not_found: 'Email Not Found',
        email_sent: 'An email has been sent to reset your password',
        check_email: 'Please check your email inbox',
    },
    login: {
        log_in_if_registered: 'Login (for registered users)',
        dont_have_account: "Don't have an account? click",
        here: 'here',
        to_sign_up: 'to signup',
        email: 'Email',
        password: 'Password',
        log_in: 'Login',
        log_in_failed: 'Login Failed',
        default_error: 'An Error Has Accured',
        wrong_password: 'Wrong Password',
        no_existing_email:
            'Email address was not found, or your signup request has not been verified yet',
        user_blocked:
            'Your user is blocked. Please contact the System Managers',
        forgot_password: 'Forgot Password',
        login_restricted_to_members: 'For Irgun Members Only',
        not_signed_yet: "?Don't Have An Account",
        signup_here: 'Signup Here',
    },
    profile: {
        headline: 'Profile',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email Address',
        id: 'ID',
        cell_number: 'Mobile Phone Number',
        another_phone: 'Additional Phone Number',
        address: 'Address',
        instructor_type: 'Membership Type',
        membership_number: 'Membership Number',
        select: 'Select',
        max_parallel_orders: 'Maximum Parallel Orders',
    },
    user_menu_headlines: {
        main_page: 'Main',
        contact_us: 'Contact Us',
        profile: 'Profile',
        logout: 'Logout',
    },
    edit_user: {
        select: 'Select',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        id: 'ID Number',
        cell_number: 'Mobile Phone Number',
        another_phone: 'Another Phone Number',
        address: 'Address',
        instructor_type: 'Membership Type',
        membership_number: 'Membership Number',
        max_parallel_orders: 'Maximum Parallel Orders',
        membership_paid: 'Membership Paid',
        admin: 'Admin',
        headline: 'Edit Membership Details',
        save_button: 'Save',
        cancel_button: 'Cancel',
        save_changes_modal_headline: 'Save Changes',
        save_changes_modal_content:
            'Are you sure you want to save your changes?',
        changes_succussfully_saved_modal_title: 'Changes saved successfully!',
        changes_succussfully_saved_modal_content: '',
        yes: 'Yes',
        no: 'No',
    },
    table: {
        show_more_details: 'Show more details',
        show_less_details: 'Show less details',
        presenting_results: 'Presenting results',
        out_of: 'Out of',
        search: 'Search',
        export: 'Export',
        list: 'List',
    },
    dances_table: {
        dance_name: 'Dance Name',
        status: 'Status',
        choreographer: 'Choreographer',
        style: 'Dance Type',
        performer: 'Performer',
        composer: 'Composer',
        lyricist: 'Lyricist',
        approval_date: 'Approval Date',
        request_date: 'Request Date',
        akum_id: 'ACUM ID',
        edit: 'Edit',
        user_details: 'User Details',
    },
    dances_table_filters: {
        dances_title: 'Dances',
        status: 'Status',
        choreographer: 'Choreographer',
        style: 'Dance Type',
        performer: 'Performer',
        composer: 'Composer',
        lyricist: 'Lyricist',
    },
    dances_expanded_row: {
        original_name: 'Original Song Name',
        co_choreographers: 'Additional Choreographer',
        request_date: 'Request Date',
        approval_date: 'Approval Date',
        completion_date: 'Dance Year',
        notes: 'Notes',
        link_to_lyrics: 'Song Lyrics Link',
        link_to_original_song: 'Song Video Link',
        link_to_dance_video: 'Dance Video Link',
    },
    users_table: {
        first_name: 'שם פרטי',
        last_name: 'שם משפחה',
        status: 'סטטוס',
        ordered: 'מוזמנים',
        confirmed: 'מאושרים',
        exists: 'קיימים',
        max_parallel_orders: 'מקס׳ הז׳ במקביל',
        admin: 'מנהל',
        dances: 'ריקודים',
        edit: 'עריכה',
    },
    users_table_filters: {
        users_title: 'משתמשים',
        search: 'חיפוש משתמשים',
        choreographer_type: 'סוג משתמש',
        status: 'סטטוס',
        max_parallel_orders: 'מספר הזמנות מקסימלי',
    },
    users_expanded_row: {
        cell: 'מס׳ סלולרי',
        another_phone: 'טלפון נוסף',
        address: 'כתובת',
        member_id: 'מס׳ חבר',
        choreographer_type: 'סוג משתמש',
        email: 'דואר אלקטרוני',
    },
    logs_table: {
        action: 'סוג פעולה',
        created: 'תאריך',
        user_name: 'משתמש מבצע',
        user_email: 'אימייל מ.מבצע',
        user_is_admin: 'סוג מ.מבצע',
        dance_name: 'שם ריקוד',
        target_user_name: 'משתמש מטרה',
        target_user_email: 'אימייל משתמש מטרה',
        description: 'תיאור',
    },
    logs_table_filters: {
        logs_title: 'פעולות מערכת',
        search: 'חיפוש',
        action_type: 'סוג פעולה',
        choreographer_name: 'שם משתמש מבצע',
        user_type: 'סוג משתמש מבצע',
        from_date: 'מתאריך',
        to_date: 'עד תאריך',
    },
    settings_headers: {
        email_distributor: 'עורך הפצת אימיילים',
        email_editor: 'עריכת אימיילים',
        general: 'הגדרות כלליות',
        users_log: 'לוג משתמשים',
    },
    buttons: {
        add_new_dance: 'Order New Song',
        pay_membership: 'Membership Payment',
        to_year: 'To Year',
        remaining: 'Remaining',
        songs: 'Songs',
    },
    edit_dance: {
        ordered_by: 'Ordered by',
        song_name: 'Song Name',
        status: 'Status',
        edit_dance: 'Edit Dance',
        add_dance: 'Add Dance',
        select: 'Select',
        dance_style: 'Dance Type',
        co_choreographers: 'Additional Choreographer',
        order_date_and_time: 'Order Date and Time',
        compeletion_date: 'Completion Date',
        link_to_dance: 'Dance Video Link',
        link_to_song: 'Song Video Link',
        link_to_lyrics: 'Song Lyrics Link',
        notes: 'Notes',
        additional_info:
            'Once the dance registration is approved, you will need to add a link to the dance video in order to complete registration.',
        minimum_search_length_error: 'You must type at least 3 characters ',
        search_song_in_akum: 'Search a Song in ACUM',
        canael_order: 'Cancel Order',
        cancel_edit: 'Cancel Edit',
        dance_name_changeable: 'Dance Name (you can change later)',
        perform_new_akum_search: 'Perform new search in ACUM',
        original_song_name: 'Original Song Name',
        akum_id: 'ACUM ID',
        translated_version_id: 'Translated ACUM ID',
        song_publication_year: 'Song Publication Year',
        performer: 'Performer',
        composer: 'Composer',
        lyricist: 'Lyricist',
        approval_date: 'Approval Date',
        manual_registration_request:
            'Please enter the song details manually, or',
        perform_new_search: 'perform new search in ACUM',
        required_fields: 'Mandatory Fields',
        no_akum_search_error: 'Song was not searched in ACUM yet',
        save: 'Save',
        send_request: 'Send Request',
        delete_dance: 'Delete Dance',
        reject_dance: 'דחה ריקוד',
        confirm_delete_dance: 'Are you sure you want to delete the dance?',
        confirm_reject_dance: 'Are you sure you want to reject the dance?',
        confirm_request: 'Confirm Request',
        confirm_confirm_request:
            'Are you sure you want to approve the request?',
        make_dance_exist: 'Change dance status to "existing"',
        confirm_make_dance_exist:
            'Are you sure you want to change dance status to "existing"?',
        reject_reason: 'Reject Reason',
        delete_reason: 'Delete Reason',
        confirm_reason: 'Approval Note',
        input_missing: 'One (or more) Mandatory Fields Are Missing',
    },
    modals: {
        confirm: 'Confirm',
        error: 'Error',
        dance_updated_successfully: 'Dance updated successfully',
        back_to_dances_screen: 'Back to dances screen',
        request_recieved: 'Your request was submitted',
        request_under_review:
            'The system admin will review your request and respond soon',
        video_url_empty: 'Missing dance video link',
        video_url_empty_description:
            'Dance status cannot change to "existing" without a video link',
    },
    akum_results_table: {
        back_to_add_dance: 'Back to New Dance screen',
        search_of_song: 'Search Song',
        in_the_database_of: 'in ACUM Database',
        cant_find_the_song: 'Can’t find the song?',
        fill_song_manualy: 'and enter the song details manually',
        work_name: 'Song Name',
        work_id: 'ACUM ID',
        composer: 'Composer',
        lyricist: 'Lyricist',
        performer: 'Performer',
        show_versions: 'Show Versions',
        choose_version: 'Choose Version',
        musical_versions: 'Musical Versions',
        translated_versions: 'Translated ',
        songs: 'Songs',
        filter_by_performer: 'Filter by performer',
        search_song_and_performer: 'Search song with performer at ACUM',
        minimum_search_length_error: 'You must type at least 3 characters',
        version_search_for_song: 'Search version to the song',
        cant_find_the_version: 'Can’t find the version?',
        and_go_back_to_songs_screen: 'and go back to songs screen',
        version_number: 'Version ID',
        publication_date: 'Publication Date',
        dance_alreay_exists: 'The dance already exists in the system',
        click_here: 'Click Here',
    },
    headers: {
        dances: 'Dances',
        my_dances: 'My Dances',
        users: 'Users',
        settings: 'Settings',
        hello: 'Hello',
    },
}
